import { useEffect, useState, type ReactNode } from "react";
import { Link, useLocation } from "react-router-dom";
import { PUBLIC_ROUTES } from "../../routes";

interface MarketingShellProps {
  children: ReactNode;
  pageClass?: string;
}

export default function MarketingShell({ children, pageClass }: MarketingShellProps) {
  const [menuOpen, setMenuOpen] = useState(false);
  const { pathname } = useLocation();

  useEffect(() => {
    setMenuOpen(false);
  }, [pathname]);

  return (
    <div className={`sg-site${pageClass ? ` ${pageClass}` : ""}`}>
      <header className="sg-nav">
        <Link to={PUBLIC_ROUTES.landing} className="sg-logo" aria-label="Manifold Kinetics home">
          <img src="/favicon.svg" alt="" aria-hidden="true" />
          <span className="sg-wordmark">
            Manifold <span>Kinetics</span>
          </span>
        </Link>
        <button
          className="sg-nav-toggle"
          type="button"
          aria-expanded={menuOpen}
          aria-controls="primary-navigation"
          onClick={() => setMenuOpen((open) => !open)}
        >
          <span aria-hidden="true">{menuOpen ? "Close" : "Menu"}</span>
          <span className="sr-only">Toggle primary navigation</span>
        </button>
        <nav
          id="primary-navigation"
          className={`sg-nav-links${menuOpen ? " is-open" : ""}`}
          aria-label="Primary navigation"
        >
          <Link to={PUBLIC_ROUTES.robotwins}>RoboTwins</Link>
          <Link to={PUBLIC_ROUTES.maternal}>Maternal AI</Link>
          <Link to={PUBLIC_ROUTES.agedCare}>Aged Care</Link>
          <Link to={PUBLIC_ROUTES.essentials}>Ground Truth</Link>
          <Link to={PUBLIC_ROUTES.howItWorks}>How it works</Link>
          <Link to={PUBLIC_ROUTES.compliance}>Compliance</Link>
          <Link to={PUBLIC_ROUTES.about}>About</Link>
          <Link to={PUBLIC_ROUTES.contact}>Contact</Link>
          <Link to={PUBLIC_ROUTES.login}>Login</Link>
          <Link to="/dashboard" className="sg-nav-dashboard">
            Dashboard
          </Link>
        </nav>
      </header>

      <main>{children}</main>

      <footer className="sg-footer">
        <div>
          <Link to={PUBLIC_ROUTES.landing} className="sg-footer-logo">
            <span className="sg-wordmark">
              Manifold <span>Kinetics</span>
            </span>
          </Link>
          <p>
            The intelligence and safety layer for caring humanoids.
            We don&rsquo;t build the robot — we build the part a
            family, a plant manager, and an insurer have to trust.
          </p>
        </div>
        <div className="sg-footer-links">
          <Link to={PUBLIC_ROUTES.robotwins}>RoboTwins</Link>
          <Link to={PUBLIC_ROUTES.productScanToSim}>Scan-to-Sim</Link>
          <Link to={PUBLIC_ROUTES.maternal}>Maternal AI</Link>
          <Link to={PUBLIC_ROUTES.productIntelligenceCore}>Intelligence Core</Link>
          <Link to={PUBLIC_ROUTES.agedCare}>Aged Care</Link>
          <Link to={PUBLIC_ROUTES.productEdgeReflex}>Edge Reflex</Link>
          <Link to={PUBLIC_ROUTES.essentials}>Ground Truth</Link>
          <Link to={PUBLIC_ROUTES.howItWorks}>How it works</Link>
          <Link to={PUBLIC_ROUTES.productLocalMind}>Local Mind</Link>
          <Link to={PUBLIC_ROUTES.about}>About</Link>
          <Link to={PUBLIC_ROUTES.nightShift}>Night Shift</Link>
          <Link to={PUBLIC_ROUTES.compliance}>Compliance</Link>
          <Link to={PUBLIC_ROUTES.contact}>Contact</Link>
          <Link to={PUBLIC_ROUTES.login}>Login</Link>
        </div>
      </footer>
    </div>
  );
}
